import { Empty } from 'antd'

import { RouteItem } from '@eastcoal/router/types/route'

import { BaseLayout } from '../layouts/BaseLayout'
import { MallLayout } from '../layouts/MallLayout'
import { applyAnnouncementRoute } from '../pages/Content/Announcement/Apply/route'
import { transactionAnnouncementRoute } from '../pages/Content/Announcement/Transaction/route'
import { newsListRoute } from '../pages/Content/News/route'
import { noticeRoute } from '../pages/Content/Notice/route'
import { supplyDemandContentRoute } from '../pages/Content/SupplyDemand/route'
import { debuggerRoute } from '../pages/Debugger/route'
import { homeRoute } from '../pages/Home/route'
import { listingRoute } from '../pages/Listing/route'
import { newsHomeRoute } from '../pages/News/route'
import { searchRoute } from '../pages/Search/route'
import { chemicalZoneRoute } from '../pages/SpecialZone/Chemical/route'
import { coalZoneRoute } from '../pages/SpecialZone/Coal/route'
import { priceCompareApplyRoute } from '../pages/TradeSession/Apply/route'
import { auctionDetailRoute } from '../pages/TradeSession/Detail/Auction/Biz/route'
import { auctionMockRoute } from '../pages/TradeSession/Detail/Auction/Mock/route'
import { priceCompareDetailRoute } from '../pages/TradeSession/Detail/PriceCompare/route'
import { tradeSessionListRoute } from '../pages/TradeSession/List/route'

export const routes: RouteItem[] = [
  { element: <BaseLayout />, children: [homeRoute] },
  {
    element: <MallLayout />,
    children: [
      debuggerRoute,
      searchRoute,
      applyAnnouncementRoute,
      transactionAnnouncementRoute,
      noticeRoute,
      supplyDemandContentRoute,
      {
        title: '竞价交易',
        hideChildrenInMenu: true,
        children: [
          tradeSessionListRoute,
          auctionDetailRoute,
          auctionMockRoute,
          priceCompareDetailRoute,
          priceCompareApplyRoute
        ]
      },
      coalZoneRoute,
      chemicalZoneRoute,
      newsHomeRoute,
      newsListRoute,
      {
        title: '网上商城',
        path: '/mall',
        element: <Empty />
      },
      listingRoute
    ]
  }
]
